import { useResource } from '@landsbankinn/l16n';
import { useInputValidation, Input } from '@landsbankinn/ui';
import React from 'react';
import res from './CustomerInfo.res';

interface IProps {
  placeholder: string;
  onChange: (val: string) => void;
  value: string;
}

export function PhoneInput({ placeholder, onChange, value }: IProps) {
  const { r } = useResource();
  const [ref, isValid, errorMessage] = useInputValidation(value, [
    {
      validation: (val) => !!val && val.length >= 7 && /^\+?\d+$/.test(val),
      message: r(res.phoneErrorMessage),
    },
  ]);
  return (
    <Input
      labelVariant="aboveInput"
      errorMessageVariant="insideInput"
      errorMessage={errorMessage}
      aria-required
      variant="noBorder"
      inputRef={ref}
      label={placeholder}
      value={value}
      isValid={isValid}
      onChange={(e) => {
        onChange(e.currentTarget.value);
      }}
    />
  );
}
